import { render } from "./Comp4.vue?vue&type=template&id=2671c414&scoped=true&ts=true"
import script from "./Comp4.vue?vue&type=script&lang=ts"
export * from "./Comp4.vue?vue&type=script&lang=ts"

import "./Comp4.vue?vue&type=style&index=0&id=2671c414&scoped=true&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2671c414"]])

export default __exports__